import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Bell } from "lucide-react";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

/**
 * One-time consent gate shown the first time a user turns on price tracking.
 * Turning tracking on implies opting in to price-alert emails.
 */
const PriceAlertConsentDialog = ({ open, onOpenChange, onConfirm }: Props) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-sm">
      <DialogHeader>
        <div className="w-10 h-10 rounded-full bg-accent/30 flex items-center justify-center mb-2">
          <Bell className="w-5 h-5 text-foreground" />
        </div>
        <DialogTitle className="text-left">Get price alerts?</DialogTitle>
        <DialogDescription className="text-left">
          We'll check this piece once a day and email you whenever the price
          moves — up or down. One email a day at most, covering everything
          you're tracking. You can turn alerts off any time in your account.
        </DialogDescription>
      </DialogHeader>
      <DialogFooter className="flex-row gap-2 sm:justify-start">
        <button
          onClick={() => onOpenChange(false)}
          className="flex-1 py-2.5 text-xs tracking-normal border border-border text-muted-foreground hover:text-foreground rounded-full"
        >
          Not now
        </button>
        <button
          onClick={onConfirm}
          className="flex-1 py-2.5 text-xs font-semibold tracking-normal bg-primary-strong text-primary-strong-foreground rounded-full hover:opacity-90 transition-opacity"
        >
          Track price
        </button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export default PriceAlertConsentDialog;
